import RekomendasiService from "../../services/keanggotaan/rekomendasi.service";

export const Rekomendasi = {
    data() {
      return {
        optionRekomendasi : [],
        modelRekomendasi : [],
        modelFilterRekomendasi : []
      };
    },
    methods: {
      getAllRekomendasi() {
        RekomendasiService.getSuratRekomendasi()
          .then(response => {
              this.optionRekomendasi = response.data.data
              this.modelFilterRekomendasi = [
                  {
                      namaRekomendasi : this.optionRekomendasi[0].namaRekomendasi
                  }
              ];
              this.formFilter.idRekomendasi = this.optionRekomendasi[0].idRekomendasi
              this.getData(0, 10, 'default', this.optionRekomendasi[0].idRekomendasi)

          }).catch(error => {
              // comment console console.log(error)
          })
      }
    }
  };